import { createSlice } from '@reduxjs/toolkit';
import userProvider from 'data-access/user-provider';
import { Profile, ServiceInfo } from 'types/model/user';

interface CommonSliceState {
  userInfo: Profile;
  serviceInfo: ServiceInfo;
}

const initialState: CommonSliceState = {
  userInfo: {} as Profile,
  serviceInfo: {} as ServiceInfo
};

export const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    updateData: (state, action) => {
      const data = action.payload || {};
      const keys = Object.keys(data);
      keys.forEach((key) => {
        state[key] = data[key];
      });
    },
    updateUserInfo: (state, action) => {
      state.userInfo = action.payload;
    }
  }
});

export const { updateData, updateUserInfo } = commonSlice.actions;

export const getUserInfo = () => {
  return async (dispatch) => {
    try {
      const res = await userProvider.getUserProfile();

      dispatch(updateUserInfo(res?.data || {}));
    } catch (err) {
      console.error(err);
    }
  };
};

export const selectUserInfo = (state) => state.common.userInfo;

export default commonSlice.reducer;
